import {AudioBridgeEvent} from "../../../constants/Janus/AudioBridge";
import {PluginStatus} from "../../../constants/Janus";

interface AudioBridgeAction {
    type: AudioBridgeEvent;
    payload?: any;
}

interface AudioBridgeState {
    mixerPlugin: any;
    opaqueId: string;
    pluginStatus: PluginStatus;
    myId: number | undefined;
    error: string;
    consentDialog: boolean;
    iceState: string;
    mediaState: any;
    webrtcState: boolean;

    joined: boolean;
    muted: boolean;
    webrtcUp: boolean;
    destroyed: boolean;
    participants: any[];
    errorEvent: any;
    remoteStream: any;
    cleanup: boolean;
}

export const initialAudioBridgeState = {
    mixerPlugin: null,
    opaqueId: "",
    pluginStatus: PluginStatus.None,
    myId: undefined,
    error: "",
    consentDialog: false,
    iceState: "",
    mediaState: null,
    webrtcState: false,

    joined: false,
    muted: false,
    webrtcUp: false,
    destroyed: false,
    participants: [],
    errorEvent: null,
    remoteStream: null,
    cleanup: false,
}

function arrayUnion(arr1: any[], arr2: any[], equalityFunc: any) {
    let union = arr1.concat(arr2);

    for (let i = 0; i < union.length; i++) {
        for (let j = i+1; j < union.length; j++) {
            if (equalityFunc(union[i], union[j])) {
                union[i] = {...union[i], ...union[j]}
                union.splice(j, 1);
                j--;
            }
        }
    }

    return union;
}

function areParticipantsEqual(p1: any, p2: any) {
    return p1?.id === p2?.id;
}


export const audioBridgeReducer = (state: AudioBridgeState, {type, payload}: AudioBridgeAction) => {
    switch (type) {
        case AudioBridgeEvent.SUCCESS:
            return {
                ...state,
                pluginStatus: PluginStatus.Attached
            };
        case AudioBridgeEvent.ERROR:
            return {
                ...state,
                pluginStatus: PluginStatus.Error,
                error: payload
            }
        case AudioBridgeEvent.CONSENT_DIALOG:
            return {
                ...state,
                consentDialog: payload
            }
        case AudioBridgeEvent.ICE_STATE:
            return {
                ...state,
                iceState: payload
            }
        case AudioBridgeEvent.MEDIA_STATE:
            return {
                ...state,
                mediaState: payload
            }
        case AudioBridgeEvent.WEBRTC_STATE:
            return {
                ...state,
                webrtcState: payload
            }
        case AudioBridgeEvent.JOINED:
            return {
                ...state,
                joined: true,
                myId: payload?.id ? payload?.id : undefined,
                participants: payload.participants ? arrayUnion(state.participants, payload.participants, areParticipantsEqual) : state.participants
                // participants: payload.participants ? [...state.participants.filter((p: any) => !payload.participants.some((np: any) => np.id === p.id)), ...payload.participants] : state.participants
            }
        case AudioBridgeEvent.DESTROYED:
            return {
                ...state,
                destroyed: true
            }
        case AudioBridgeEvent.PARTICIPANTS:
            return {
                ...state,
                participants: arrayUnion(state.participants, payload, areParticipantsEqual)
                // participants: [...state.participants.filter((p: any) => !payload.some((np: any) => np.id === p.id)), ...payload]
            }
        case AudioBridgeEvent.ERROR_EVENT:
            return {
                ...state,
                errorEvent: payload
            }
        case AudioBridgeEvent.LEAVING:
            return {
                ...state,
                participants: state.participants.filter((p: any) => p.id !== payload)
            }
        case AudioBridgeEvent.TALKING:
            let newTalking = state.participants.map((p: any) => {
                if (p.id === payload) {
                    p.talking = true;
                }
                return p;
            })
            return {
                ...state,
                participants: newTalking
            }
        case AudioBridgeEvent.STOPPED_TALKING:
            let newNotTalking = state.participants.map((p: any) => {
                if (p.id === payload) {
                    p.talking = false;
                }
                return p;
            })
            return {
                ...state,
                participants: newNotTalking
            }
        case AudioBridgeEvent.ON_REMOTE_STREAM:
            return {
                ...state,
                remoteStream: payload
            }
        case AudioBridgeEvent.ON_CLEAN_UP:
            return {
                ...state,
                cleanup: true
            }
        case AudioBridgeEvent.SET:
            return {
                ...state,
                [payload.key]: payload.value,
            };
        default:
            return state
    }
}
